// src/pages/GSTCategoryForm.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import API_BASE_URL from '../../utils/config';

const GSTCategoryForm = () => {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [gstPercent, setGstPercent] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      axios.get(`${API_BASE_URL}/api/gstCategories/${id}`).then((res) => {
        setName(res.data.name);
        setGstPercent(res.data.gst_percent);
      });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await axios.put(`${API_BASE_URL}/api/gstCategories/${id}`, { name, gst_percent: parseFloat(gstPercent) });
      } else {
        await axios.post(`${API_BASE_URL}/api/gstCategories`, { name, gst_percent: parseFloat(gstPercent) });
      }
      navigate('/gstCategories');
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-xl font-bold mb-4">{id ? 'Edit' : 'Add'} GST Category</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block">Category Name</label>
          <input type="text" className="border p-2 w-full" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div>
          <label className="block">GST %</label>
          <input type="number" step="0.01" className="border p-2 w-full" value={gstPercent} onChange={(e) => setGstPercent(e.target.value)} required />
        </div>
        <button className="bg-green-600 text-white px-4 py-2 rounded">{id ? 'Update' : 'Save'}</button>
      </form>
    </div>
  );
};

export default GSTCategoryForm;
